import fetch from '../utils/fetch';

// 域账号登录-内部系统
interface LoginData {
    // username: string | undefined;
    // password: string | undefined;
    target: string | undefined;
    account_type: number | undefined;
    pass_info: string | false;
}
export const loginApi = async (data: LoginData): Promise<any> => {
    return fetch({
        url: `/api/login`,
        method: 'post',
        data
    });
}

// 验证短信验证码登录
interface ValidSmsData {
    mobile: string | undefined;
    code: string | undefined;
    target: string | undefined;
    account_type: number |undefined;
}
export const validSmsApi = async (data: ValidSmsData): Promise<any> => {
    return fetch({
        url: `/api/validSms`,
        method: 'post',
        data
    });
}

// 获取页面信息
interface PageDetailData {
    id: string | undefined;
    sp: string | undefined;
    target: string | undefined;
}
export const pageDetailApi = async (params: PageDetailData): Promise<any> => {
    return fetch({
        url: `/api/getPageDetail`,
        method: 'get',
        params
    });
}

// 发送验证码
interface SendSmsData {
    mobile: string | undefined;
    target: string | undefined;
}
export const sendSmsApi = async (params: SendSmsData): Promise<any> => {
    return fetch({
        url: `/api/sendSms`,
        method: 'get',
        params
    });
}

// Code换Token
interface Code2TokenData {
    code: string;
}
export const code2TokenApi = async (params: Code2TokenData): Promise<any> => {
    return fetch({
        url: `/api/code2Token`,
        method: 'get',
        params
    });
}

// 飞书获取Code
interface FeiShuCodeData {
    fs_code: string;
    target?: string;
    account_type: number;
    id?: string;
    sp?: string;
}
export const feiShuCodeApi = async (params: FeiShuCodeData): Promise<any> => {
    return fetch({
        url: `/api/getCode`,
        method: 'get',
        params
    });
}

// 钉钉获取Code
interface DdCodeData {
    dt_code: string;
    target?: string;
    account_type: number;
    id?: string;
    sp?: string;
}
export const ddCodeApi = async (params: DdCodeData): Promise<any> => {
    return fetch({
        url: `/api/dt/getCode`,
        method: 'get',
        params
    });
}

// Token换Code (用于主站Token换取子站的code)
interface Token2CodeData {
    target: string;
}
export const token2CodeApi = async (params: Token2CodeData): Promise<any> => {
    return fetch({
        url: `/api/token2Code`,
        method: 'get',
        params
    });
}

// 检查token是否有效
export const checkTokenApi = async (): Promise<any> => {
    return fetch({
        url: `/api/checkToken`,
        method: 'get',
        params: {
            check_type: 2
        }
    });
}

// 设置cookie
interface SetCookieData {
    token: string;
}
export const setCookieApi = async (data: SetCookieData): Promise<any> => {
    return fetch({
        url: `/api/setCookie`,
        method: 'post',
        data
    });
}

// 神盾登录
interface ShieldLoginData {
    host: string;
    goto: string;
    authorization: string;
}
export const shieldLoginApi = async (data: ShieldLoginData): Promise<any> => {
    return fetch({
        url: `${data.host}/sso/api/shield/login`,
        method: 'post',
        data
    });
}

// SAML 阿里云、火山登录
interface ThirdIdpLoginData {
    sp: string;
    code: string;
    goto: string;
}
export const thirdIdpLoginApi = async (data: ThirdIdpLoginData): Promise<any> => {
    return fetch({
        url: `/api/third/idp`,
        method: 'post',
        data
    });
}

// SAML 华为登录
interface ThirdAttrIdpLoginData {
    sp: string;
    code: string;
    goto: string;
    sig_alg: string;
    signature: string;
}

export const thirdAttrIdpLoginApi = async (data: ThirdAttrIdpLoginData): Promise<any> => {
    return fetch({
        url: `/api/third/attr/idp`,
        method: 'post',
        data
    });
}

// SAML 蓝湖、mastergo登录
interface ThirdGoogleIdpLoginData {
    sp: string;
    code: string;
    goto: string;
    sig_alg: string;
    signature: string;
}

export const thirdGoogleIdpLoginApi = async (data: ThirdGoogleIdpLoginData): Promise<any> => {
    return fetch({
        url: `/api/third/google/idp`,
        method: 'post',
        data
    });
}

// OIDC登录
interface OidcBuildAuthCodeLoginData {
    id: string
}

export const oidcBuildAuthCodeLoginApi = async (params: OidcBuildAuthCodeLoginData): Promise<any> => {
    return fetch({
        url: `/api/oidc/buildAuthCode`,
        method: 'get',
        params
    });
}

// 获取服务端公钥
interface PublicKeyData {
    id: string | undefined;
    sp: string | undefined;
    target: string | undefined;
}
export const publicKey = async (params: PublicKeyData): Promise<any> => {
    return fetch({
        url: `/api/p/key`,
        method: 'get',
        params
    });
}